import React from 'react'
var Title = function (props) {
  return React.createElement(
    'g',
    null,
    React.createElement(
      'text',
      { className: props.className, x: props.coords.x, y: props.coords.y },
      props.text
    )
  )
}
export default Title
